
import { Directive, EventEmitter, HostListener, Output } from "@angular/core";


@Directive({ selector: '[hebrewCharater]' })
export class HebrewCharactersDirective {
 @Output('hebrewCharater') hebrewCharater = new EventEmitter<String>();

 
 @HostListener('input', ['$event'])
 onKeyInput(event: InputEvent) {
  this.hebrewCharater.emit("");
  const inputElement = event.target as HTMLInputElement;
  const elementId = inputElement.id;

  const hasHebrewCharacters = /[א-ת]/.test(inputElement.value);
  if (hasHebrewCharacters) {
    inputElement.value = inputElement.value.replace(/[א-ת]/g, '');
     this.hebrewCharater.emit(elementId);
   
   }

 }
}

@Directive({ selector: '[capsLock]' })
export class TrackCapsDirective {
  @Output('capsLock') capsLock = new EventEmitter<String>();

  @HostListener("click", ['$event'])
  onClick(event: KeyboardEvent ): void {
    let elementId: string = (event.target as Element).id; 
    this.capsLock.emit("");
    if(event.getModifierState && event.getModifierState('CapsLock')){
    this.capsLock.emit(elementId);
   } 
  
  }
  
  @HostListener('window:keydown', ['$event'])
  onKeyInput(event: KeyboardEvent): void {
    this.capsLock.emit("");
    if(event.getModifierState && event.getModifierState('CapsLock')){
        let elementId: string = (event.target as Element).id; 
        this.capsLock.emit(elementId);
    }
  }
  


}


